"use client";

import React from "react";
import s from "../styles";

export default function CarRepairDataArea({ data }) {
  const req = data?.request;

  if (!req?.GenshaID) return null;

  const hasKatashiki = !!req?.Taisho_Katashiki;

  return (
    <s.DetailTable>
      <s.DetailCaption>修理対象車輌情報</s.DetailCaption>
      <tbody>
        <tr>
          <s.DetailTh>メーカー名</s.DetailTh>
          <s.DetailTd>{req?.Taisho_MakerName}</s.DetailTd>
          <s.DetailTh>車名</s.DetailTh>
          <s.DetailTd>{req?.Taisho_CarName}</s.DetailTd>
        </tr>
        <tr>
          {hasKatashiki ? (
            <>
              <s.DetailTh>型式指定・類別区分</s.DetailTh>
              <s.DetailTd>
                {req?.Taisho_Katashiki} - {req?.Taisho_Ruibetsu}
              </s.DetailTd>
            </>
          ) : (
            <>
              <s.DetailTh>車輌型式</s.DetailTh>
              <s.DetailTd>{req?.Taisho_SharyoKatashiki}</s.DetailTd>
            </>
          )}
          <s.DetailTh>車台番号</s.DetailTh>
          <s.DetailTd>{req?.Taisho_ShadaiBango}</s.DetailTd>
        </tr>
      </tbody>
    </s.DetailTable>
  );
}
